// @flow
import * as React from 'react';

const MapMarker = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    style={{ verticalAlign: 'middle' }}
  >
    <defs>
      <clipPath id="clip-path">
        <path
          d="M69.48 256.28a2.29 2.29 0 1 1 0-4.57h2.31V254a2.3 2.3 0 0 1-2.31 2.28"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path d="M72.21 251.29v-4.57a4.49 4.49 0 0 1 4.63 4.57z" className="cls-1" />
      </clipPath>
      <clipPath id="clip-path-3">
        <path d="M74.61 256.28a2.28 2.28 0 0 1-2.4-2.23v-2.34h4.63v4.57z" className="cls-1" />
      </clipPath>
      <clipPath id="clip-path-4">
        <path d="M71.79 249a2.32 2.32 0 1 1-2.32-2.28 2.3 2.3 0 0 1 2.32 2.28" className="cls-1" />
      </clipPath>
    </defs>
    <path
      fill="#018436"
      d="M12 3a6.81 6.81 0 0 1 6.8 6.8c0 3.11-3.76 7.67-6.79 10.52C9.41 17.86 5.2 13.17 5.2 9.8A6.81 6.81 0 0 1 12 3m0-2a8.8 8.8 0 0 0-8.8 8.8C3.2 15.65 12 23 12 23s8.8-7.35 8.8-13.2A8.8 8.8 0 0 0 12 1z"
      className="cls-2"
    />
    <path
      fill="#018436"
      d="M12 8a2 2 0 1 1-2 2 2 2 0 0 1 2-2m0-2a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"
      className="cls-2"
    />
  </svg>
);

export { MapMarker };
